import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../../components/shared/Loading";
import PageContainer from "../../../../components/template/PageContainer";
import {
  parseNonEmptyParams,
  protectedLeaf,
} from "../../../../router/route-contracts";

const Screen = lazy(
  () => import("../../../../views/answer/QuestionnairePreview"),
);

export const Route = createFileRoute("/_protected/answer/$surveyId/preview")({
  component: RouteComponent,
  params: {
    parse: parseNonEmptyParams,
  },
  staticData: protectedLeaf({
    requiredRoles: [],
    routeKey: "questionnaireAnswerPreview",
    access: "protected",
    layout: "blank",
    container: "default",
    leafKind: "preview",
  }),
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
